import { queryOptions } from "@tanstack/react-query";
import { $getCitationDetail, $getProjectCitations } from "~/lib/citations/functions";
import { $getProject, $getProjects } from "./functions";

export const projectsQueryOptions = () =>
  queryOptions({
    queryKey: ["projects"],
    queryFn: ({ signal }) => $getProjects({ signal }),
  });

export const projectQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId],
    queryFn: ({ signal }) => $getProject({ signal, data: { projectId } }),
    staleTime: 30000, // Cache for 30s to avoid refetching on navigation
  });

export const projectCitationsQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "citations"],
    queryFn: ({ signal }) => $getProjectCitations({ signal, data: { projectId } }),
  });

export const citationDetailQueryOptions = (projectId: string, citationId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "citations", citationId, "detail"],
    queryFn: ({ signal }) =>
      $getCitationDetail({ signal, data: { projectId, citationId } }),
    staleTime: 0,
  });
